function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.929 21.608c6.5 2.786 18.571 2.786 24.143 0 0-6.667-5.405-12.071-12.071-12.071S15.93 14.942 15.93 21.608z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.051 16.646C47.885 17.833 54 20.398 54 23.372c0 4.103-11.641 7.429-26 7.429S2 27.475 2 23.372c0-3.002 6.047-5.588 15.016-6.76"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54 24.301c0 5.664-11.641 8.357-26 8.357S2 29.965 2 24.301"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.464,
  cy: 27.18,
  rx: 2.321,
  ry: 0.929
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-6.457)",
  cx: 34.548,
  cy: 30.422,
  rx: 2.321,
  ry: 0.929
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "scale(-1 1) rotate(-6.457)",
  cx: -22.019,
  cy: 24.02,
  rx: 2.321,
  ry: 0.929
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-18.017)",
  cx: 37.299,
  cy: 37.393,
  rx: 2.321,
  ry: 0.929
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "scale(-1 1) rotate(-18.017)",
  cx: -17.376,
  cy: 19.631,
  rx: 2.321,
  ry: 0.929
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.857 31.823l-.929 9.286"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.714 42.037c0 .513-1.447.478-2.986.478-1.538 0-2.585.035-2.585-.478s1.247-.929 2.785-.929c1.539 0 2.786.416 2.786.929z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.143 31.823l.929 9.286"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.286 42.037c0 .513 1.447.478 2.986.478s2.585.035 2.585-.478-1.247-.929-2.785-.929c-1.539 0-2.786.416-2.786.929z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 20c.833-3.671 3.359-6.046 7-8-1.421 2.978-2.86 5.627-3.9 8.7z"
}));

var SvgFlyingsaucer = function SvgFlyingsaucer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlyingsaucer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Flying saucer.dd511d6f.svg";
export { ForwardRef as ReactComponent };